import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "@/libs/builder/commonFields";

export const modalBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Modal",
  noWrap: true,
  inputs: [
    {
      name: "isOpen",
      type: "boolean",
      helperText: "Set to true to open the modal when page is initially loaded",
      localized: false,
    },
    {
      name: "mount",
      type: "boolean",
      defaultValue: false,
      helperText:
        "Set to true to have always content of the modal in the DOM even when closed.",
      localized: false,
    },
    {
      name: "modalId",
      type: "string",
      required: true,
      defaultValue: "modal-default",
      helperText:
        'Unique Modal Id used to open the modal (set event with "Open Modal" action)',
      localized: false,
    },
    {
      name: "variant",
      type: "enum",
      required: true,
      defaultValue: "standard",
      enum: [
        {
          label: "Standard",
          value: "standard",
        },
        {
          label: "Slim",
          value: "slim",
        },
        {
          label: "Exit Intent",
          value: "exitIntent",
        },
        {
          label: "Minimal",
          value: "minimal",
        },
      ],
      localized: false,
    },
    {
      name: "onClose",
      type: "javascript",
      required: false,
      localized: false,
    },
    {
      name: "idleTime",
      friendlyName: "Idle Time",
      type: "number",
      defaultValue: 60,
      helperText:
        "Time in seconds after which the modal will open when there is no user activity.",
      localized: false,
      showIf: "options.get('variant') === 'exitIntent'",
    },
    {
      name: "closeAnalytics",
      type: "object",
      subFields: [DLT_FIELD, DLD_FIELD],
    },
  ],
  shouldReceiveBuilderProps: {
    builderContext: true,
  },
  canHaveChildren: true,
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Text",
        options: {
          text: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Lorem ipsum",
          },
        },
      },
      meta: {
        localizedTextInputs: ["text"],
        "transformed.text": "localized",
      },
    },
  ],
};
